export const PROFILE_LIST = [
  {
    label: '自己PR・ひとことPR',
    link: '/mypage/profile/edit/pr_message',
  },
  {
    label: '学歴',
    link: '/mypage/profile/edit/education',
  },
  {
    label: '志望・志向',
    link: '/mypage/profile/edit/wish',
  },
  {
    label: 'インターンシップ経験',
    link: '/mypage/profile/edit/intern',
  },
  {
    label: '開発・プログラミング経験',
    link: '/mypage/profile/edit/it_skill',
  },
  {
    label: '内定/内々定先',
    link: '/mypage/profile/edit/offer?mode=edit',
  },
  {
    label: 'その他経験',
    link: '/mypage/profile/edit/other',
  },
  {
    label: '言語スキル・海外在住経験',
    link: '/mypage/profile/edit/language',
  },
];

export type ProfileListItem = {
  label: string;
  link: string;
};
